module.exports = __webpack_public_path__ + "fonts/manrope-medium.d67747cf.woff2";